import { styled } from '../../styled';
import type { Theme } from '../../theme/interface/detailed';
import { borderRadiusFix } from '../../utils/borderRadiusFix';
import { DarkenedContainerBase } from './darkenedContainer/base';

export const AfterRatingContainer = styled(DarkenedContainerBase)(
	({
		theme: {
			afterRatingField: {
				containers: { afterRatingContainer },
			},
			allSettings: {
				containers: {
					chatContainer: { borderRadius },
				},
			},
		},
	}: {
		theme: Theme;
	}) => ({
		...afterRatingContainer,
		borderRadius,
	}),
	borderRadiusFix()
);
